
import { defineComponent, PropType, ref } from 'vue'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import FreeFormsFormFiledDescriptionTranslationDomain from '@/components/free-forms/form-fields/description-translation-domain.vue'
import FreeFormsFormFiledDescriptionTranslationEnglish from '@/components/free-forms/form-fields/description-translation-english.vue'
import { useFreeFormsModule } from '@/modules/free-forms'
import { AddTranslationDomain } from '@/modules/free-forms/types'
import { TRIAL_FORMS_CONTEXT } from '@/modules/free-forms/api'

export default defineComponent({
    name: 'free-forms-create-new-translation-domain-dialog',
    components: {
        FreeFormsFormFiledDescriptionTranslationDomain,
        FreeFormsFormFiledDescriptionTranslationEnglish
    },
    props: {
        updateCallback: {
            type: Function as PropType<(t: string) => void>,
            required: true
        }
    },
    setup (props) {
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
        const { submitForm, createOnSuccess } = useFormModule()
        const { addTranslationDomain } = useFreeFormsModule()
        const form = ref<QForm>()
        const domain = ref<string>()
        const english = ref<string>()

        const sendRequest = async () => await addTranslationDomain({
            context: TRIAL_FORMS_CONTEXT,
            domain: domain.value,
            english: english.value
        } as AddTranslationDomain)

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('New translation domain added')
        )
            .then(() => props.updateCallback(domain.value as string))
            .then(onDialogOK)

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            onSubmit,
            form,
            domain,
            english
        }
    }
})
